package de.connect2x.timmy.brandings.lifetimeTheme

import androidx.compose.material3.Typography
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import de.connect2x.messenger.compose.view.theme.ThemeTypography
import de.connect2x.messenger.compose.view.theme.withFontFamily
import de.connect2x.timaokwebclient.generated.resources.Lato_Black
import de.connect2x.timaokwebclient.generated.resources.Lato_BlackItalic
import de.connect2x.timaokwebclient.generated.resources.Lato_Bold
import de.connect2x.timaokwebclient.generated.resources.Lato_BoldItalic
import de.connect2x.timaokwebclient.generated.resources.Lato_Italic
import de.connect2x.timaokwebclient.generated.resources.Lato_Light
import de.connect2x.timaokwebclient.generated.resources.Lato_LightItalic
import de.connect2x.timaokwebclient.generated.resources.Lato_Regular
import de.connect2x.timaokwebclient.generated.resources.Lato_Thin
import de.connect2x.timaokwebclient.generated.resources.Lato_ThinItalic
import de.connect2x.timaokwebclient.generated.resources.Res
import org.jetbrains.compose.resources.Font

class ThemeTypographyLifetimeImpl : ThemeTypography {
    @Composable
    override fun create(): Typography {
        return Typography().withFontFamily(
            FontFamily(
                fonts = listOf(
                    // --- Thin (200) -------------------------------------------------------
                    Font(Res.font.Lato_Thin, FontWeight.ExtraLight, FontStyle.Normal),
                    Font(Res.font.Lato_ThinItalic, FontWeight.ExtraLight, FontStyle.Italic),

                    // --- Light (300) -------------------------------------------------------
                    Font(Res.font.Lato_Light, FontWeight.Light, FontStyle.Normal),
                    Font(Res.font.Lato_LightItalic, FontWeight.Light, FontStyle.Italic),

                    // --- Regular (400-500) -------------------------------------------------------
                    Font(Res.font.Lato_Regular, FontWeight.Normal, FontStyle.Normal),
                    Font(Res.font.Lato_Italic, FontWeight.Normal, FontStyle.Italic),

                    Font(Res.font.Lato_Regular, FontWeight.Medium, FontStyle.Normal),
                    Font(Res.font.Lato_Italic, FontWeight.Medium, FontStyle.Italic),

                    // --- Bold (600-700) -----------------------------------------------------------
                    Font(Res.font.Lato_Bold, FontWeight.SemiBold, FontStyle.Normal),
                    Font(Res.font.Lato_BoldItalic, FontWeight.SemiBold, FontStyle.Italic),

                    Font(Res.font.Lato_Bold, FontWeight.Bold, FontStyle.Normal),
                    Font(Res.font.Lato_BoldItalic, FontWeight.Bold, FontStyle.Italic),

                    // --- Black (800-900) -----------------------------------------------------------
                    Font(Res.font.Lato_Black, FontWeight.ExtraBold, FontStyle.Normal),
                    Font(Res.font.Lato_BlackItalic, FontWeight.ExtraBold, FontStyle.Italic),

                    Font(Res.font.Lato_Black, FontWeight.Black, FontStyle.Normal),
                    Font(Res.font.Lato_BlackItalic, FontWeight.Black, FontStyle.Italic),
                )
            )
        )
    }
}
